import React, { useEffect } from "react";

/** Bottom-sheet modal on mobile, centered dialog on desktop. */
export default function Sheet({ open, onClose, title, children, footer, widthClass="max-w-xl" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = e => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-testid="sheet">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} data-testid="sheet-backdrop" />
      <div className={`relative bg-white w-full ${widthClass} sm:rounded-2xl rounded-t-2xl shadow-xl
                       max-h-[94vh] overflow-y-auto`}>
        <div className="flex items-center justify-between p-4 border-b sticky top-0 bg-white z-10">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button className="text-gray-500 hover:text-black" onClick={onClose}
                  data-testid="sheet-close">✕</button>
        </div>
        <div className="p-4">{children}</div>
        {footer && <div className="p-4 border-t sticky bottom-0 bg-white">{footer}</div>}
      </div>
    </div>
  );
}
